import { Link } from 'react-router-dom';
import { Instagram, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="mt-auto py-8" style={{ backgroundColor: 'hsl(30, 25%, 96%)', borderTop: '1px solid hsl(30, 15%, 88%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4">
          {/* Brand */}
          <div className="text-xl font-bold" style={{ fontFamily: 'Quicksand, sans-serif', color: 'hsl(345, 60%, 60%)' }}>
            Moonlit Personal Care Private Limited
          </div>

          {/* Contact Link */}
          <Link
            to="/contact"
            className="px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg"
            style={{
              backgroundColor: 'hsl(345, 60%, 60%)',
              color: 'white',
              fontFamily: 'Nunito, sans-serif'
            }}
          >
            Contact Us
          </Link>

          {/* Quick Links */}
          <div className="flex gap-6 text-sm" style={{ color: 'hsl(30, 10%, 50%)' }}>
            <a href="https://instagram.com/moonlitpersonalcare" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <Instagram size={18} />
              Instagram
            </a>
            <a href="tel:7307989892" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <Phone size={18} />
              Call Us
            </a>
            <a href="mailto:info@moonlitpersonalcare.com" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              <Mail size={18} />
              Email
            </a>
          </div>

          {/* Copyright */}
          <div className="text-sm" style={{ color: 'hsl(30, 10%, 50%)', fontFamily: 'Nunito, sans-serif' }}>
            © 2026 Moonlit Personal Care. Building a legacy with passion and integrity.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
